export default __webpack_public_path__ + "static/background-8b31aff5fa86ab69ffedf5f04415feff.jpg";